import React from 'react';
import { Card, CardContent } from './ui/card';
import { CheckCircle2 } from 'lucide-react';

const benefits = [
  'Reduces development time by 90%',
  'Eliminates boilerplate code',
  'Ensures consistent code quality',
  'Follows industry best practices',
  'Automatically implements CQRS pattern',
  'Includes comprehensive unit tests',
  'Built-in dependency injection',
  'Implements repository pattern',
  'Includes API versioning',
  'Swagger/OpenAPI documentation',
  'Entity Framework Core integration',
  'AutoMapper configuration'
];

export const BenefitsSection = () => {
  return (
    <section id="benefits" className="py-20 lg:py-32 bg-muted/30">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
              Why Choose APIfromSQL.com?
            </h2>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Our Intelligence-powered platform understands Clean Architecture principles and generates 
              production-ready code that follows .NET best practices. Save time, reduce errors, 
              and focus on building features that matter.
            </p>
            
            {/* Benefits List */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                  <span className="text-foreground">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content - Code Preview */}
          <Card className="border-2 shadow-xl bg-card">
            <CardContent className="p-8">
              <div className="bg-secondary/10 rounded-lg p-6 border border-border">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-3 h-3 rounded-full bg-destructive"></div>
                  <div className="w-3 h-3 rounded-full bg-warning"></div>
                  <div className="w-3 h-3 rounded-full bg-success"></div>
                  <span className="text-xs text-muted-foreground ml-2">Generated Code Structure</span>
                </div>
                <div className="font-mono text-sm space-y-2">
                  <div className="text-primary">📁 YourProject.API</div>
                  <div className="text-muted-foreground ml-4">📁 Controllers</div>
                  <div className="text-primary ml-0 mt-2">📁 YourProject.Application</div>
                  <div className="text-muted-foreground ml-4">📁 Commands</div>
                  <div className="text-muted-foreground ml-4">📁 Queries</div>
                  <div className="text-muted-foreground ml-4">📁 DTOs</div>
                  <div className="text-primary ml-0 mt-2">📁 YourProject.Domain</div>
                  <div className="text-muted-foreground ml-4">📁 Entities</div>
                  <div className="text-muted-foreground ml-4">📁 Interfaces</div>
                  <div className="text-primary ml-0 mt-2">📁 YourProject.Infrastructure</div>
                  <div className="text-muted-foreground ml-4">📁 Data</div>
                  <div className="text-muted-foreground ml-4">📁 Repositories</div>
                </div>
              </div>
              <div className="mt-6 p-4 bg-primary/5 rounded-lg border border-primary/20">
                <p className="text-sm text-foreground font-medium">
                  ✨ Complete Clean Architecture structure generated in seconds
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
